<template>
  <v-sheet
    class="transactionTable pb-3"
    :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'"
  >
    <div class="title-bar">
      <div>
        <v-icon dense color="#5F7692">mdi-bag-checked</v-icon>
        <span class="ml-2">Recent Transactions</span>
      </div>
      <v-spacer></v-spacer>
      <router-link class="links pr-4" to="/transaction-history">See All Transactions ></router-link>
    </div>
    <DataTable></DataTable>
  </v-sheet>
</template>

<script>
import DataTable from "./DataTable.vue";
export default {
  components: { DataTable },
};
</script>
